import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@shared/ui/dialog";

export const TemplatePreviewDialog = ({ open, onOpenChange, templateData }) => {
  const subject = templateData?.content?.subject || "--";
  const body = templateData?.content?.body || "--";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-hidden">
        <DialogHeader>
          <DialogTitle>Template Preview</DialogTitle>
        </DialogHeader>

        {/* Scrollable Content */}
        <div className="border rounded-md p-4 bg-gray-50 max-h-[65vh] overflow-y-auto">
          <div className="mb-2 text-sm text-gray-600 font-medium">Subject:</div>
          <div className="font-semibold text-gray-900 break-words">{subject}</div>

          <hr className="my-3" />

          <p className="text-gray-800 whitespace-pre-wrap break-words">
            {body}
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};
